<template>
  <div class="bar-box">
    <div class="bar-box-title">关键指标</div>
    <!-- <div class="tabs">
      <span
        class="item"
        v-for="tab in tabs"
        :key="tab.value"
        :class="{ active: tab.value === activeTab }"
        @click="handleTabClick(tab.value)"
        >{{ tab.name }}</span
      >
    </div> -->
    <div id="bar-chart" style="width: 100%; height: 100%"></div>
  </div>
</template>
<script setup>
import * as echarts from "echarts";
import { onMounted, ref } from "vue";
const tabs = [
  {
    name: "报告数量",
    value: "report_count",
  },
  {
    name: "CT",
    value: "CT_count",
  },
  {
    name: "MRI",
    value: "MRI_count",
  },
  {
    name: "DR",
    value: "DR_count",
  },
  {
    name: "头部",
    value: "head_count",
  },
  {
    name: "胸部",
    value: "chest_count",
  },
  {
    name: "腹部",
    value: "abdomen_count",
  },
  {
    name: "盆腔",
    value: "pelvis_count",
  },
  {
    name: "四肢",
    value: "limb_count",
  },
  {
    name: "其他",
    value: "other_count",
  },
];
const activeTab = ref("report_count");
const handleTabClick = (value) => {
  activeTab.value = value;
  setChart();
};
const generateHospitalData = () => {
  const rates = () => +(Math.random() * 5 + 95).toFixed(2); // 生成 95.00-99.99 的随机比率
  const ratesNum = () => Math.floor(Math.random() * 500) + 100; // 生成 100-1000 的随机总数

  return Array.from({ length: 50 }, (_, i) => {
    const total = Math.floor(Math.random() * 900) + 500; // 100-1000 的随机总数

    return {
      month: i + 1,
      report_count: total,
      qc_report_count: ratesNum(),
      qc_image_count: ratesNum(),
      // 设备故障率
      device_fault_rate: rates(),
      // 诊断合格率
      diagnosis_rate: rates(),
    };
  });
};
const dataList = generateHospitalData();
onMounted(() => {
  setChart();
});
const setChart = () => {
  // 清除echarts实例
  let data = dataList.slice(0, 12);
  console.log(data, dataList);
  const myChart = echarts.init(document.getElementById("bar-chart"));
  myChart.setOption({
    title: {
      show: false,
    },
    legend: {
      show: true,
      data: ["报告不良数量", "影像不良数量", "设备健康率", "诊断合格率"],
      textStyle: {
        color: "#7ec6fc",
      },
      top: "10",
    },
    grid: {
      left: "40",
      right: "30",
      bottom: "20",
      top: "50",
    },
    xAxis: {
      type: "category",
      data: data.map((item) => item.month),
      axisLabel: {
        formatter: function (value) {
          return value;
        },
        color: "#7ec6fc",
      },
    },
    // 双Y轴
    yAxis: [
      {
        type: "value",
        axisLabel: {
          formatter: function (value) {
            return value;
          },
          color: "#7ec6fc",
        },
        splitLine: {
          lineStyle: {
            color: "#2a3f66",
          },
        },
      },
      {
        type: "value",
        axisLabel: {
          formatter: function (value) {
            return value;
          },
          color: "#7ec6fc",
        },
        splitLine: {
          show: false,
        },
      },
    ],
    series: [
      {
        name: "报告不良数量",
        data: data.map((item) => {
          return item.qc_report_count;
        }),
        type: "bar",
        itemStyle: {
          color: "#5470c680",
        },
        yAxisIndex: 0,
      },
      {
        name: "影像不良数量",
        data: data.map((item) => {
          return item.qc_image_count;
        }),
        type: "bar",
        itemStyle: {
          color: "#73c0de80",
        },
        yAxisIndex: 0,
      },
      {
        name: "设备健康率",
        data: data.map((item) => {
          return item.device_fault_rate;
        }),
        type: "line",
        itemStyle: {
          color: "#ee6666",
        },
        yAxisIndex: 1,
      },
      {
        name: "诊断合格率",
        data: data.map((item) => {
          return item.diagnosis_rate;
        }),
        type: "line",
        itemStyle: {
          color: "#5470c6",
        },
        yAxisIndex: 1,
      },
    ],
  });
};
</script>
<style scoped>
.bar-box {
  background: #1b2a4c;
  border-radius: 8px;
  color: #7ec7fd;
  padding: 16px;
  font-size: 16px;
  min-height: 120px;
  text-align: left;
  display: flex;
  flex-direction: column;
  .tabs {
    flex: 0 0 20px;
    display: flex;
    font-size: 12px;
    background-color: #2a3f66;
    border-radius: 5px;
    padding: 5px;
    margin: 10px 0;
    .item {
      text-align: center;
      cursor: pointer;
      margin-right: 10px;
      display: inline-block;
      height: 20px;
      line-height: 20px;
      border-bottom: 1px solid transparent;
    }
    .item:hover,
    .item.active {
      color: #fff;
      border-bottom: 1px solid #7ec7fd;
    }
  }
  #bar-chart {
    flex: 1;
  }
}
</style>
